import Store from 'lightningjs-redux';
import CTA from '../../cta/cta.constants';
import { createItemAction } from '../../cta/cta.actions';
import { getItemActionType } from '../../cta/cta.utils';
import { NOTIFICATION_SIGNAL } from '../../tornado/signals';
import { PLACEHOLDER } from '../../tornado/utils/virtualization';
import { NOTIFICATION_LEVEL, makeNotification } from '../../tornado/notifications';
import { t } from '../../i18n';

export * from './platform/default/app.utils';
export * from './platform/default/rcu.utils';

export const showSnackbar = (root, level, message) => {
  root.fireAncestors(`$${NOTIFICATION_SIGNAL}`, makeNotification(level, message));
};

export const handleInteraction = (item, root) => {
  if (item && item.id && item.id !== PLACEHOLDER.id) {
    Store.dispatch(createItemAction({ item }));

    const type = getItemActionType(item);

    if (type === CTA.BOOKMARK) {
      showSnackbar(root, NOTIFICATION_LEVEL.SUCCESS, t('bookmarks.added'));
    } else if (type === CTA.UNBOOKMARK) {
      showSnackbar(root, NOTIFICATION_LEVEL.SUCCESS, t('bookmarks.removed'));
    }
  }
};
